import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'mce-responsive-action-button',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './mce-responsive-action-button.component.html',
})
export class MceRseponsiveActionButtonComponent {

  icon = input<string>();
  label = input<string>();
  disabled = input<boolean>(false);

  buttonClick = output<MouseEvent>();


}
